export const getCredentialRequestRedirectUrl = credentialRequest => {
  if (!credentialRequest) {
    return null;
  }

  return `${process.env.REACT_APP_AUTH_URL}/connect/${credentialRequest.packageType}/${credentialRequest.requestId}`;
};

export default getCredentialRequestRedirectUrl;
